import React, { FC, useMemo, useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import Nav from 'react-bootstrap/Nav';
import styled from 'styled-components';
import { FaBook } from 'react-icons/fa';
import { useTranslation } from 'react-i18next';
import AddToHomeScreenComponent from 'components/add-to-homescreen/AddToHomeScreenComponent';

const FooterComponent: FC = () => {
  const [isMobile, setIsMobile] = useState(false);
  const { t } = useTranslation();

  useEffect(() => {
    const mediaQuery = window.matchMedia('(max-width: 768px)');
    const handler = (event: MediaQueryListEvent) => setIsMobile(event.matches);
    mediaQuery.addEventListener('change', handler);
    setIsMobile(mediaQuery.matches);

    return () => mediaQuery.removeEventListener('change', handler);
  }, []);

  const getCurrentYear = useMemo(() => {
    return new Date().getFullYear();
  }, []);

  return (
    <Footer>
      <Copyright className="mt-2 mt-md-0">
        {getCurrentYear}&copy; {t('common.fullName')}
      </Copyright>
      <Nav className="ml-md-auto flex-column align-items-center align-items-md-start flex-md-row">
        <Link
          to={{
            pathname: 'https://ehr.bg/',
          }}
          target="_blank"
          className="nav-link"
        >
          {t('menu.aboutUs')}
        </Link>
        <Link
          to={{
            pathname: 'https://ehr.bg/',
          }}
          target="_blank"
          className="nav-link"
        >
          {t('menu.privacyPolicy')}
        </Link>
        <Link
          to={{
            pathname: '/training-materials',
          }}
          className="nav-link"
        >
          <FaBook className="mr-1 mb-1" />
          {t('menu.trainingMaterials')}
        </Link>
        {isMobile && (
          <AddToHomeScreenComponent
            label="addToHomescreen.install"
            type="button"
          />
        )}
      </Nav>
    </Footer>
  );
};

export default FooterComponent;

const Footer = styled.div`
  padding: 0.75rem 2rem;
  background: ${props => props.theme.colors.white};
  box-shadow: ${props => props.theme.boxShadow};
  display: flex;
  align-items: center;

  .nav {
    a {
      color: inherit;
      &:hover {
        color: ${props => props.theme.colors.violet};
      }
    }
  }

  @media ${props => props.theme.breakpoints.lg} {
    padding: 0.75rem 1rem;
  }

  @media ${props => props.theme.breakpoints.md} {
    height: auto;
    flex-direction: column-reverse;

    .nav {
      width: 100%;
    }
  }
`;

const Copyright = styled.div`
  @media ${props => props.theme.breakpoints.md} {
    width: 100%;
    text-align: center;
    padding-top: 8px;
    border-top: 1px solid ${props => props.theme.colors.light};
  }
`;
